export default "__VITE_ASSET__4184900d__"